/**
 * Role and permission constants.
 * A single isAdmin field in the user profile indicates admin level:
 * - isAdmin === 'super' → super admin (full access)
 * - isAdmin === true or isAdmin === 'admin' → admin
 * - falsy → not admin
 * Legacy: isSuperAdmin flag or SUPER_ADMIN_EMAIL is still respected for backward compatibility.
 */
export const SUPER_ADMIN_EMAIL = 'v.sai.vishnu@gmail.com';

/** True if profile has any admin capability (admin or super admin). */
export function isAdminRole(userOrProfile) {
  if (!userOrProfile) return false;
  const v = userOrProfile.isAdmin;
  return v === true || v === 'true' || v === 'admin' || v === 'super' ||
    userOrProfile.isSuperAdmin === true || userOrProfile.isSuperAdmin === 'true';
}

/** True if profile is super admin (from isAdmin === 'super' or legacy isSuperAdmin or email). */
export function isSuperAdmin(userOrProfile) {
  if (!userOrProfile) return false;
  const v = userOrProfile.isAdmin;
  if (v === 'super') return true;
  const legacy = userOrProfile.isSuperAdmin === true || userOrProfile.isSuperAdmin === 'true';
  if (legacy) return true;
  const email = (userOrProfile.email || '').toString().toLowerCase().trim();
  return email === SUPER_ADMIN_EMAIL.toLowerCase();
}
